export const requestEmailPageForm = {
  next: 'Avançar',
  back: 'Voltar',
  email: {
    label: 'E-mail',
    invalid: 'E-mail inválido',
    required: 'E-mail obrigatório',
  },
};
